import React, { Component } from 'react';
import { GET_LIST, UPDATE, GET_ONE } from 'admin-on-rest';
import PropTypes from 'prop-types';
import {
  AutoComplete,
  TextField,
  List,
  IconButton,
  SelectField,
  MenuItem,
  RaisedButton,
} from 'material-ui';
import Remove from 'material-ui/svg-icons/content/remove';
import { trim, get } from 'lodash';
import { restClient } from '../../App';
import { regscape } from '../../utils/StringUtils';
import { getTranslationByLocale } from '../../utils/TranslationUtils';
import './style.css';

const listStyle = {
  maxHeight: '600px',
};
export default class Alias extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      selectedAlias: {},
      inputAlias: [],
      selectedProduct: '',
    };
  }

  componentDidMount = async () => {
    await restClient(GET_LIST, 'products', {
      sort: {},
      pagination: {},
      filter: {},
    }).then((res) => {
      const { locale } = this.props;
      this.setState({ products: dataConfigFormatter(res.data, locale) });
    });
  }

  handleSelect = async (product) => {
    await restClient(GET_ONE, 'alias', { id: product.code })
      .then((res) => this.setState({ selectedAlias: res.data }))
      .catch((e) => { console.log('Could not find any aliases', e); this.setState({ selectedAlias: {} }); });
    this.setState({ selectedProduct: product.code });
  }

  handleAddAlias = () => {
    const { inputAlias, selectedProduct, type } = this.state;
    const alias = inputAlias.map((a) => trim(a));
    restClient(UPDATE, 'alias', { id: selectedProduct, data: { values: alias, action: 'add', type } })
      .then((res) => {
        console.log('es', res);
        this.setState({ selectedAlias: res.data });
      });
  }

  handleRemoveAlias = (value, product, type) => {
    restClient(UPDATE, 'alias', { id: product, data: { value: trim(value), action: 'remove', type } })
      .then((res) => {
        console.log('ress', res);
        this.setState({ selectedAlias: res.data });
      });
  }

  handleInputAlias = (e, value) => {
    this.setState({ inputAlias: [value] });
  }

  handleSearch = (searchText) => this.setState({ searchText })

  handleTypeChange = (e, i, type) => this.setState({ type });

  formatValue = (value) => value.join(',')

  render() {
    const { products, inputAlias, selectedAlias, type, searchText } = this.state;
    const { translate } = this.props;
    console.log('this.props', this.props, this.state);
    return (
      <div className="alias-wrapper">
        <AutoComplete
          floatingLabelText={translate('resources.alias.chooseProduct')}
          fullWidth
          listStyle={listStyle}
          searchText={searchText}
          dataSource={products}
          dataSourceConfig={{ text: 'text', value: 'code' }}
          onNewRequest={(req) => this.handleSelect(req)}
          filter={(searchText, key) => searchText.length > 1 && // eslint-disable-line no-shadow
              new RegExp(
                regscape(searchText),
                'gi'
              ).test(key) // @returns bool
          }
        />
        <div className="fields">
          <AliasInput value={this.formatValue(inputAlias)} handleInput={this.handleInputAlias} action="add" translate={translate} />

          <SelectField
            floatingLabelText={translate('resources.alias.type')}
            onChange={this.handleTypeChange}
            value={type}
          >
            <MenuItem value="alias" primaryText={translate('resources.alias.alias')} />
            <MenuItem value="similar" primaryText={translate('resources.alias.similar')} />
          </SelectField>

          <div className="icons">
            <RaisedButton children={translate('add')} onClick={this.handleAddAlias}></RaisedButton>
          </div>
        </div>
        {
          Object.keys(selectedAlias).length > 0 && (
            <List>
              {
                <div className="row-wrapper">
                  {get(selectedAlias, 'alias', []).sort((a, b) => a > b ? 1 : -1).map((alias) => (
                    <div key={alias} className="row">
                      <div className="column">{alias}</div>
                      <div className="column">{selectedAlias.product}</div>
                      <div className="column">{translate('resources.alias.alias')}</div>
                      <IconButton children={<Remove color="red" />} onClick={() => this.handleRemoveAlias(alias, selectedAlias.product, 'alias')}></IconButton>
                    </div>
                  ))}
                  {get(selectedAlias, 'similar', []).sort((a, b) => a > b ? 1 : -1).map((similar) => (
                    <div key={similar} className="row">
                      <div className="column">{similar}</div>
                      <div className="column">{selectedAlias.product}</div>
                      <div className="column">{translate('resources.alias.similar')}</div>
                      <IconButton children={<Remove color="red" />} onClick={() => this.handleRemoveAlias(similar, selectedAlias.product, 'similar')}></IconButton>
                    </div>
                  ))}
                </div>
              }
            </List>
          )
        }
      </div>
    );
  }
}

Alias.propTypes = {
  translate: PropTypes.func,
};

const AliasInput = ({ value, handleInput, translate }) => (
  <div className="alias">
    <TextField
      floatingLabelText={translate('resources.alias.enterAlias')}
      name="aliasInput"
      value={value}
      onChange={handleInput}
      errorText={translate('resources.alias.errorText')}
      errorStyle={{ color: 'darkslategrey' }}
      className="alias-field"
      fullWidth
    />
  </div>
);

const dataConfigFormatter = (products, locale) => products.map((p) => ({ ...p, text: `${getTranslationByLocale(p.title, locale)}, ${p.internalName}` }));
